enum ApiEndpoint {
	USER_REGISTRATION = 'USER_REGISTRATION',
	DEACTIVATE_USER = 'DEACTIVATE_USER',
	EDIT_USER_REGISTRATION = 'EDIT_USER_REGISTRATION',
}

export default ApiEndpoint;
